import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { senderService, SendEmailParams } from '../../services/resend/sender.service'

interface EmailsState {
  isSending: boolean
  isSuccess: boolean
  error: string | null
  lastEmailId: string | null
}

const initialState: EmailsState = {
  isSending: false,
  isSuccess: false,
  error: null,
  lastEmailId: null,
}

// Async thunk to send an email
export const sendEmail = createAsyncThunk(
  'emails/sendEmail',
  async (emailParams: SendEmailParams, { rejectWithValue }) => {
    try {
      const response = await senderService.sendEmail(emailParams)
      return response
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to send email')
    }
  }
)

const emailsSlice = createSlice({
  name: 'emails',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    },
    resetEmailState: (state) => {
      state.isSending = false
      state.isSuccess = false
      state.error = null
      state.lastEmailId = null
    },
  },
  extraReducers: (builder) => {
    // Send email
    builder
      .addCase(sendEmail.pending, (state) => {
        state.isSending = true
        state.isSuccess = false
        state.error = null
      })
      .addCase(sendEmail.fulfilled, (state, _) => {
        state.isSending = false
        state.isSuccess = true
        state.error = null
        state.lastEmailId = null
      })
      .addCase(sendEmail.rejected, (state, action) => {
        state.isSending = false
        state.isSuccess = false
        state.error = action.payload as string
      })
  },
})

export const { clearError, resetEmailState } = emailsSlice.actions

export default emailsSlice.reducer